export default "__VITE_PUBLIC_ASSET__f9659c90__"